import Backbone from 'backbone';
import {ERROR, SUCCESS} from 'common/constants';
import {t} from 'common/utils/translation-util';

Backbone.$ = $;

export default Backbone.Collection.extend({
  clearCachedValues() {
    // Override
  },

  constructor(...args) {
    this.attributeName = '';
    this.errorMessage = t('Data failed to load.');
    this.params = undefined;
    this.restHost = window.settings.hosts.rest;
    this.wwwHost = window.settings.hosts.www;
    this.timeout = 60000;
    this.type = undefined;
    this.urlFunc = Function;
    Backbone.Collection.apply(this, args);
    return this;
  },

  fetchJSON(params) {
    params.restHost = this.restHost;
    params.wwwHost = this.wwwHost;
    this.clearCachedValues();
    this.url = this.urlFunc(params);
    const fetchOptions = this.getFetchOptions ? this.getFetchOptions() : {};
    return this.fetch({
      error: this.onError,
      success: this.onSuccess,
      reset: true,
      ...fetchOptions,
    });
  },

  getAttribute(attributeName, modelIndex) {
    let model = this.at(0);
    if (modelIndex) {
      model = this.at(modelIndex);
    }
    if (model) {
      const attributes = model.attributes;
      if (attributes && attributes.hasOwnProperty(attributeName)) {
        return attributes[attributeName];
      }
    }
  },

  getAttributeName() {
    return this.attributeName;
  },

  getResults() {
    const results = this.getAttribute('results');
    return results ? results : [];
  },

  sync(method, model, options) {
    options.dataType = 'jsonp';
    options.timeout = this.timeout;
    return Backbone.sync(method, model, options);
  },

  onError(collection, response, options) {
    collection.trigger(ERROR, {target: collection}, response, options);
  },

  onSuccess(collection, response, options) {
    collection.trigger(SUCCESS, {target: collection}, response, options);
  },
});
